import { combineReducers } from 'redux-immutable'
import consentListReducer from './consent-management-list-reducer'
import consentCreateReducer from './consent-management-create-reducer'
import consentEditReducer from './consent-management-edit-reducer'
import consentExportReducer from './consent-management-export-reducer'
import consentGetReducer from './consent-management-get-reducer'
import consentDeactivateReducer from './consent-management-deactivate-reducer'

export default combineReducers({
    consentList: consentListReducer,
    consentCreate: consentCreateReducer,
    consentEdit: consentEditReducer,
    consentExport: consentExportReducer,
    consentGet: consentGetReducer,
    consentDeactivate: consentDeactivateReducer,
})


// WEBPACK FOOTER //
// ./src/reducers/consent-management/index.js